import React, { useState, useEffect } from "react";
import { database } from '../firebase';
import { Helmet } from 'react-helmet-async';
import { ref, get, child } from 'firebase/database';
const Rules = ({ title, description }) => {
  const [laws, setLaws] = useState([]);
  const [visibleLaws, setVisibleLaws] = useState({});
  useEffect(() => {
    const fetchLaws = async () => {
      try {
        const dbRef = ref(database); // Reference to the Firebase database
        const lawsSnapshot = await get(child(dbRef, "laws"));
        if (lawsSnapshot.exists()) {
          const data = lawsSnapshot.val();
          const formattedLaws = Object.keys(data).map((key) => ({
            id: key,
            ...data[key],
          }));
          setLaws(formattedLaws);
        } else {
          console.log("No data available");
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchLaws(); // Call the function to fetch data when the component mounts
  }, []);

  const toggleLaw = (id) => {
    setVisibleLaws((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  return (
    <>
      <>
      
    <Helmet>
    <title>{title || 'Rules - EnbyBase Official Website'}</title>
    <meta name="description" content={description || 'Entire Rule Provisions of EnbyBase • TransBase'} />
    <meta property="og:title" content={title || 'Rules - EnbyBase Official Website'}/>
    <meta property="og:description" content={description || 'Entire Rule Provisions of EnbyBase • TransBase'}/>
  </Helmet>
  <div id="main-area">
  <div id="article">
  <div className="rpp-law-container">
      <Helmet>
        <title>List of Laws</title>
        <meta name="description" content="List of legal documents and amendments." />
      </Helmet>
      <h1 className="rpp-law-header">List of Laws</h1>
      <div className="rpp-law-list">
        {laws.map((law) => (
          <div key={law.id} className="rpp-law-item">
            <div className="rpp-law-title-row">
              <h2 className="rpp-law-title">{law.title}</h2>
              <button
                className="rpp-law-toggle-button"
                onClick={() => toggleLaw(law.id)}
              >
                {visibleLaws[law.id] ? "Close" : "Open"}
              </button>
            </div>
            {visibleLaws[law.id] && (
              <div className="rpp-law-content">
                <p>
                  <strong>Amendment Date:</strong> {law.amenddate}
                </p>
                <a
                  href={law.pdfLink}
                  className="rpp-law-pdf-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
    </div></div></div>
    </>
    </>
  );
}

export default Rules;